export const SCAN_SOUND_MUTED_STORAGE_KEY = "scanner.soundMuted";

export const scanSoundPreferenceChangeEvent = "worksuite:scan-sound-preference-change";

export const readScanSoundMuted = (): boolean => {
	try {
		return localStorage.getItem(SCAN_SOUND_MUTED_STORAGE_KEY) === "true";
	} catch {
		return false;
	}
};

export const writeScanSoundMuted = (muted: boolean): void => {
	localStorage.setItem(SCAN_SOUND_MUTED_STORAGE_KEY, String(muted));
};

export default readScanSoundMuted;
